export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14498.1332777c.jpg";